<!-- SEARCH_BAR -->
<!-- Table -->
<div class="m-auto">
  <div class="overflow-auto table-cont">
    <app-loader-widget *ngIf="recordsManager.isLoading" class="loader-w" [isLoader]="recordsManager.isLoading">
    </app-loader-widget>

    <div class="h-[500px] relative z-0">
      <mat-table style="min-width: 100%;" [style.opacity]="recordsManager.isLoading ? '0.5' : '1'" class="w-fit"
        [dataSource]="dataSource" matSort [matSortActive]="displayedColumns ? displayedColumns[0] : ''"
        matSortDirection="asc" matSortDisableClear [matSortDisabled]="!disableSort && recordsManager.isLoading">

        <ng-container *ngFor="let col of filteredCols; index as i" [matColumnDef]="col.columnDef" [sticky]="col.sticky">
          <ng-container *ngIf="col.visible">
            <mat-header-cell mat-sort-header [disabled]="!disableSort || !col.sortable" *matHeaderCellDef
              [style.minWidth]="col.minWidth || '180px'" class="flex flex-col items-center justify-center">
              {{(col?.header || '' | translate) | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element" class="bg-gray-50 even:bg-white flex flex-col  w-fit"
              [style.minWidth]="col.minWidth || '180px'"
              [ngClass]="{'light-accent-bg visited opened': (recordsManager.strategyService.elementWasVisited ? (recordsManager.strategyService.elementWasVisited(element) | async) : false), 'second': true, 'third': false, 'items-start justify-center overflow-auto scrollbar-hide' :col?.header==='recoveryPlanTable.title', 'items-center justify-center ' :col?.header!=='recoveryPlanTable.title' }">
              <ng-template cellHost [colConfig]="col" [componentData]="element">
              </ng-template>
            </mat-cell>
          </ng-container>

        </ng-container>


        <!-- <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef [style.minWidth]="actionColMinWidth"></mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex justify-end" [style.minWidth]="actionColMinWidth">
          <app-custom-buttons class="flex" [buttons]="actions" [element]="element"
            (buttonClick)="onActionClick($event, element)"></app-custom-buttons>

        </mat-cell>
      </ng-container> -->


        <mat-header-row class=" border-[1px] border-y-[#223E80] text-xs font-extralight bg-gray-50 z-50"
          *matHeaderRowDef="displayedColumns; sticky:true">
        </mat-header-row>


        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <tr class="mat-row " *matNoDataRow fxLayout>

          <div class="w-screen text-center mt-3">
            <div style="min-height: 64px;">
              {{utils.traslatei18n("notElementFound")}}
            </div>
          </div>

          <td class="mat-cell" fxFlex="100" fxLayoutAlign="start center">
          </td>
        </tr>
      </mat-table>
    </div>

    <mat-paginator class="hidden" [pageSize]="sizes.length && sizes[0]"></mat-paginator>

  </div>
</div>

<div class="mt-4">

  <app-custom-paginator [paginator]="paginator"></app-custom-paginator>

</div>
